import { render, staticRenderFns } from "./ChangeOrderStatus.vue?vue&type=template&id=4a059d6c&scoped=true"
import script from "./ChangeOrderStatus.vue?vue&type=script&lang=js"
export * from "./ChangeOrderStatus.vue?vue&type=script&lang=js"
import style0 from "./ChangeOrderStatus.vue?vue&type=style&index=0&id=4a059d6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a059d6c",
  null
  
)

export default component.exports